/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AggregatedMetricsResponse } from '../models';
// @ts-ignore
import type { AggregationWindow } from '../models';
// @ts-ignore
import type { DashboardCallsResponse } from '../models';
// @ts-ignore
import type { DashboardMetricType } from '../models';
// @ts-ignore
import type { DashboardViewType } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { SingleCallMetricsResponse } from '../models';
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet: async (startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet', 'endTime', endTime)
            const localVarPath = `/api/v1/analytics/metrics/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1: async (startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1', 'endTime', endTime)
            const localVarPath = `/api/v1/analytics/metrics/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
         * @summary Get single call metrics
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/analytics/metrics/call/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
         * @summary Get single call metrics
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2', 'callLogId', callLogId)
            const localVarPath = `/api/v1/analytics/metrics/call/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
         * @summary Get dashboard call analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
         * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCallsApiV1AnalyticsCallsGet: async (viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewType' is not null or undefined
            assertParamExists('getDashboardCallsApiV1AnalyticsCallsGet', 'viewType', viewType)
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getDashboardCallsApiV1AnalyticsCallsGet', 'metric', metric)
            const localVarPath = `/api/v1/analytics/calls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (viewType !== undefined) {
                localVarQueryParameter['view_type'] = viewType;
            }

            if (metric !== undefined) {
                localVarQueryParameter['metric'] = metric;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
         * @summary Get dashboard call analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
         * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCallsApiV1AnalyticsCallsGet_3: async (viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewType' is not null or undefined
            assertParamExists('getDashboardCallsApiV1AnalyticsCallsGet_3', 'viewType', viewType)
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getDashboardCallsApiV1AnalyticsCallsGet_3', 'metric', metric)
            const localVarPath = `/api/v1/analytics/calls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (viewType !== undefined) {
                localVarQueryParameter['view_type'] = viewType;
            }

            if (metric !== undefined) {
                localVarQueryParameter['metric'] = metric;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet(startTime, endTime, window, organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1(startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1(startTime, endTime, window, organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
         * @summary Get single call metrics
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleCallMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
         * @summary Get single call metrics
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleCallMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
         * @summary Get dashboard call analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
         * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardCallsApiV1AnalyticsCallsGet(viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardCallsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardCallsApiV1AnalyticsCallsGet(viewType, metric, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getDashboardCallsApiV1AnalyticsCallsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
         * @summary Get dashboard call analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
         * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardCallsApiV1AnalyticsCallsGet_3(viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardCallsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardCallsApiV1AnalyticsCallsGet_3(viewType, metric, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getDashboardCallsApiV1AnalyticsCallsGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AggregatedMetricsResponse> {
            return localVarFp.getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet(startTime, endTime, window, organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1(startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AggregatedMetricsResponse> {
            return localVarFp.getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1(startTime, endTime, window, organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
         * @summary Get single call metrics
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleCallMetricsResponse> {
            return localVarFp.getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
         * @summary Get single call metrics
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleCallMetricsResponse> {
            return localVarFp.getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
         * @summary Get dashboard call analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
         * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCallsApiV1AnalyticsCallsGet(viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardCallsResponse> {
            return localVarFp.getDashboardCallsApiV1AnalyticsCallsGet(viewType, metric, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
         * @summary Get dashboard call analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
         * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardCallsApiV1AnalyticsCallsGet_3(viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardCallsResponse> {
            return localVarFp.getDashboardCallsApiV1AnalyticsCallsGet_3(viewType, metric, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
     * @summary Get aggregated metrics
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for metrics
     * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet(startTime, endTime, window, organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated call metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Maximum time range is 90 days. Requires \'analytics:view\' permission.
     * @summary Get aggregated metrics
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for metrics
     * @param {string} [organizationId] Organization ID to filter by (optional, admin only)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1(startTime: string, endTime: string, window?: AggregationWindow, organizationId?: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getAggregatedMetricsApiV1AnalyticsMetricsAggregateGet_1(startTime, endTime, window, organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
     * @summary Get single call metrics
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed metrics for a specific call. Returns all available performance and usage metrics. Requires \'analytics:view\' permission.
     * @summary Get single call metrics
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getCallMetricsApiV1AnalyticsMetricsCallCallLogIdGet_2(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
     * @summary Get dashboard call analytics
     * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
     * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getDashboardCallsApiV1AnalyticsCallsGet(viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getDashboardCallsApiV1AnalyticsCallsGet(viewType, metric, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve call analytics for dashboard visualization with rolling time windows. Supports daily (24 hourly buckets) and weekly (7 daily buckets) views. Returns either call count or duration metrics. Only includes completed calls. Requires \'analytics:view\' permission.
     * @summary Get dashboard call analytics
     * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours) or \&#39;weekly\&#39; (last 7 days)
     * @param {DashboardMetricType} metric Metric to calculate: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getDashboardCallsApiV1AnalyticsCallsGet_3(viewType: DashboardViewType, metric: DashboardMetricType, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getDashboardCallsApiV1AnalyticsCallsGet_3(viewType, metric, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

